if (!customElements.get('hitch-card-swatches')) {
  customElements.define(
    'hitch-card-swatches',
    class HitchCardSwatches extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        if (this.dataset.interactiveDesktop !== 'true') return;
        if (!window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches) return;

        this.card = this.closest('.hitch-product-card');
        this.image = this.card?.querySelector('.card__media .media > img:first-child');
        if (!this.card || !this.image) return;

        this.originalImage = {
          src: this.image.getAttribute('src'),
          srcset: this.image.getAttribute('srcset'),
          alt: this.image.getAttribute('alt'),
        };

        this.querySelectorAll('[data-hitch-card-swatch]').forEach((swatch) => {
          swatch.addEventListener('mouseenter', () => this.preview(swatch));
          swatch.addEventListener('focus', () => this.preview(swatch));
        });

        this.addEventListener('mouseleave', () => this.restore());
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.restore();
        });
      }

      preview(swatch) {
        const imageSrc = swatch.dataset.cardImageSrc;
        if (!imageSrc) return;

        this.image.removeAttribute('srcset');
        this.image.setAttribute('src', imageSrc);
        if (swatch.dataset.cardImageAlt) this.image.setAttribute('alt', swatch.dataset.cardImageAlt);
        this.card.classList.add('hitch-product-card--swatch-active');
      }

      restore() {
        if (!this.card?.classList.contains('hitch-product-card--swatch-active')) return;

        if (this.originalImage.srcset) {
          this.image.setAttribute('srcset', this.originalImage.srcset);
        } else {
          this.image.removeAttribute('srcset');
        }

        if (this.originalImage.src) this.image.setAttribute('src', this.originalImage.src);
        if (this.originalImage.alt !== null) this.image.setAttribute('alt', this.originalImage.alt);
        this.card.classList.remove('hitch-product-card--swatch-active');
      }
    }
  );
}
